import type { NicknameResponse, RegisteredVia, UserResponse } from 'src/libs/wa/models/responses/UserResponse';
import { shoppingApiBaseUrl } from 'src/utils/shoppingApiBaseUrl';
import { getLocaleFromUrl } from 'src/utils/subdomain';
import { getRequest } from './wamazingApi';

const fetchUser = async () => {
  try {
    const response = await getRequest<UserResponse>({
      baseURI: process.env.NEXT_PUBLIC_WAMAZING_API_ENDPOINT || '',
      path: '/v1/user'
    });
    return response;
  } catch (e) {
    return null;
  }
};

const fetchUserNickname = async () => {
  try {
    const response = await getRequest<NicknameResponse>({
      baseURI: shoppingApiBaseUrl(getLocaleFromUrl()),
      path: `/api/v1/users/nickname`
    });
    return response;
  } catch (e) {
    return null;
  }
};

const fetchRegisteredVia = async () => {
  try {
    const response = await getRequest<RegisteredVia | null>({
      baseURI: process.env.NEXT_PUBLIC_WAMAZING_API_ENDPOINT || '',
      path: '/v1/user/analysis'
    });

    return response;
  } catch (e) {
    return null;
  }
};

export { fetchRegisteredVia, fetchUser, fetchUserNickname };
